import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Users } from '../models/users';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UsersService extends CrudService<Users, number> {

  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/users`);
  }

  resendActivationEmail(userEmail: string): Observable<Users> {
    return this._http
      .post<Users>(`${environment.baseUrl}/account/activate_account`, {
        user_email: userEmail,
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

}

